<template>
  <a-switch
    @change="(e)=>findEvent({e})"
    v-bind="$attrs.item"
    v-model="modelList[name]"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { Switch } from "ant-design-vue";
export default {
  mixins: [formMixin],
  components: {
    [Switch.name]: Switch,
  },
  props: {
    modelList: {},
    funcList: {},
    name: {},
  },
};
</script>
